
window.reserveInStore = window.reserveInStore || window.__reserveInStore || [];
window.reserveInStore.push('on', {
    event: 'reserve_modal.submit',
    callback: function(e) {
        if(document.querySelector('[name="reservation[customer_email]"]')){
            purchaseReservePopup(document.querySelector('[name="reservation[customer_email]"]').value)
        }
    }
});
window.reserveInStore.push('on', {
    event: 'reserve_modal.create',
    callback: function() {
        if(document.querySelector('#reservation_instructions_from_customer')){
            const currentDate = new Date();
            let inputSelector = "#reservation_instructions_from_customer"
            let limitResults = {},
                minTime = "",
                maxTime = "",
                minDate = currentDate;
            if(currentDate.getDay() != 0 && currentDate.getDay() != 6){
                limitResults =  calculateTimeLimit(window.productReserveHours.workWeekStart, window.productReserveHours.workWeekEnd)
            }else if(currentDate.getDay() == 0){
                limitResults = calculateTimeLimit(window.productReserveHours.sundayStart, window.productReserveHours.sundayEnd)
            }else if(currentDate.getDay() == 6){
                limitResults = calculateTimeLimit(window.productReserveHours.saturdayStart, window.productReserveHours.saturdayEnd)
            }


            let minDateStr = `${new Date(limitResults.minDate).getFullYear()}-${new Date(limitResults.minDate).getMonth()+1}-${new Date(limitResults.minDate).getDate()}`;


            flatpickr("#reservation_instructions_from_customer", {
                appendTo: document.querySelector('.js-date-input-wrapper'),
                static: true,
                enableTime: true,
                time_24hr: true,
                disableMobile: true,
                minuteIncrement: 15,
                position: "[left][below]",
                minDate	: minDateStr,
                minTime: limitResults.minTime,
                maxTime: limitResults.maxTime,
                locale: {
                    firstDayOfWeek: 1
                },
                dateFormat: "d-m-Y | H:i",
                onChange: function (selectedDates, dateStr, instance){
                    const selectedDate = new Date(selectedDates[0]);
                    const currentDate = new Date(limitResults.minDate);
                    let results = {};

                    if(currentDate.toDateString() == selectedDate.toDateString()){           
                        if(currentDate.getDay() != 0 && currentDate.getDay() != 6){
                            results =  calculateTimeLimit(window.productReserveHours.workWeekStart, window.productReserveHours.workWeekEnd)
                        }else if(currentDate.getDay() == 0){
                            results = calculateTimeLimit(window.productReserveHours.sundayStart, window.productReserveHours.sundayEnd)
                        }else if(currentDate.getDay() == 6){
                            results = calculateTimeLimit(window.productReserveHours.saturdayStart, window.productReserveHours.saturdayEnd)
                        }
                    }else{
                        results = setDefaultTimeLimit(selectedDate);
                    }
                    instance.set("maxTime", results.maxTime)
                    instance.set("minTime", results.minTime)
                }
            });
        }
        reserveFormValidation();
        beginReservePopup();
    }
});
window.reserveInStore.push('on', {
    event: 'init',
    callback: function() {
        if(document.querySelector('#cartReserve')){
            document.querySelector('#cartReserve').removeAttribute('style')
        }
    }
});
window.reserveInStore.push('on', {
    event: 'reserve_modal.show',
    callback: function() {
        document.body.classList.add('disable-scroll');
    }
});
window.reserveInStore.push('on', {
    event: 'reserve_modal.hide',
    callback: function() {
        document.body.classList.remove('disable-scroll');
    }
});
function calculateTimeLimit(startHour, endHour){
    let currentDate = new Date(),
        currentDateEnd = new Date(),
        currentDateTemp = new Date();
    let results = {
        minTime: '',
        maxTime: '',
        minDate: '',
    }
    let resultsMinutes = clossestBigger(currentDate.getMinutes());
    let minimalGap = 2;
  
    currentDateEnd = currentDateEnd.setHours(parseInt(window.productReserveHours.workWeekEnd) - 1);
    currentDateEnd = new Date(currentDateEnd).setMinutes(30);
  
    if(new Date().getDay() == 0){
        currentDateEnd = new Date(currentDateEnd).setHours(parseInt(window.productReserveHours.sundayEnd) - 1);

    }else if(new Date().getDay() == 6){
        currentDateEnd = new Date(currentDateEnd).setHours((window.productReserveHours.saturdayEnd) - 1);
    }

    if(resultsMinutes == 59){
      minimalGap = 3;
      resultsMinutes = 0
    }

    if(currentDateTemp.setHours(currentDateTemp.getHours() + minimalGap) < currentDateEnd){
        results.minTime = `${currentDate.getHours()+minimalGap}:${resultsMinutes}`;
        results.maxTime = `${parseInt(window.productReserveHours.workWeekEnd - 1)}:30`;
        results.minDate = currentDate;
        if(new Date().getDay() == 0){
           results.maxTime = `${parseInt(window.productReserveHours.sundayEnd - 1)}:30`;
        }else if(new Date().getDay() == 6){
          results.maxTime = `${parseInt(window.productReserveHours.saturdayEnd - 1)}:30`;
      }
        
    }
    else{

        const hoursDifference = new Date(currentDateEnd).getHours() - currentDate.getHours();
        let nextDayHour = 0;
        if(hoursDifference == 2){
            nextDayHour = 0;
        }else if(hoursDifference == 1){
            nextDayHour = 1;
        }else{
            nextDayHour = 2;
        }

        results.minDate = currentDate.setDate(currentDate.getDate() + 1);
      
        if(new Date(results.minDate).getDay() == 0){
            results.minTime = `${window.productReserveHours.sundayStart + nextDayHour}:00`;
            results.maxTime = `${parseInt(window.productReserveHours.sundayEnd - 1)}:30`;

        }else if(new Date(results.minDate).getDay() == 6){
            results.minTime = `${window.productReserveHours.saturdayStart + nextDayHour}:00`;
            results.maxTime = `${parseInt(window.productReserveHours.saturdayEnd - 1)}:30`;

        }else{
            results.minTime = `${window.productReserveHours.workWeekStart + nextDayHour}:00`;
            results.maxTime = `${parseInt(window.productReserveHours.workWeekEnd - 1)}:30`;

        }
    }

    // minimalGap = 30;
    // if(currentDateTemp.setMinutes(currentDateTemp.getMinutes() + minimalGap) < currentDateEnd){
    //     results.minTime = `${currentDate.getHours()}:${currentDate.getMinutes() + minimalGap}`;
    //     results.maxTime = `${window.productReserveHours.workWeekEnd}:00`;
    //     results.minDate = currentDate;
    // }else{
    //
    //     results.minDate = currentDate.setDate(currentDate.getDate() + 1);
    //     if(new Date(results.minDate).getDay() == 0){
    //         results.minTime = `${window.productReserveHours.sundayStart}:30`;
    //         results.maxTime = `${window.productReserveHours.sundayEnd}:00`;
    //
    //     }else if(new Date(results.minDate).getDay() == 6){
    //         results.minTime = `${window.productReserveHours.saturdayStart}:30`;
    //         results.maxTime = `${window.productReserveHours.saturdayEnd}:00`;
    //
    //     }else{
    //         results.minTime = `${window.productReserveHours.workWeekStart}:30`;
    //         results.maxTime = `${window.productReserveHours.workWeekEnd}:00`;
    //
    //     }
    // }

    return results;
}
function clossestBigger(number){
 
  const candidates = [1, 15, 30, 45, 59];
  
  let bestCandidate = Infinity;
  
  const higherCandidates = candidates.filter(candidate => candidate > number);
  
  higherCandidates.forEach(candidate => {
      if (candidate < bestCandidate) bestCandidate = candidate;
  });
  
  return bestCandidate
}
function setDefaultTimeLimit(date){
    let results = {
        minTime: '',
        maxTime: '',
    }
    if(new Date(date).getDay() == 0){
        results.minTime = `${window.productReserveHours.sundayStart}:00`;
        results.maxTime = `${window.productReserveHours.sundayEnd - 1}:30`;


    }else if(new Date(date).getDay() == 6){
        results.minTime = `${window.productReserveHours.saturdayStart}:00`;
        results.maxTime = `${window.productReserveHours.saturdayEnd - 1}:30`;

    }else{
        results.minTime = `${window.productReserveHours.workWeekStart}:00`;
        results.maxTime = `${window.productReserveHours.workWeekEnd - 1}:30`;

    }
    return results;
}
function reserveFormValidation() {
    let forms = document.querySelectorAll('.js-reserve-form-validation form');
    if (!forms.length > 0) {
        return;
    }
    forms.forEach(function (form){
        let button = form.querySelector(('button:not(.reserveInStore-form-submit)'));
        button.addEventListener('click',function (e){
            e.preventDefault();
            let validation = true;
            let requiredFields = form.querySelectorAll('.second-step input[required]:not([type="checkbox"])');
            let requiredEmail = form.querySelectorAll('.second-step input[type="email"]');
            let phone = form.querySelectorAll('.second-step input[type="tel"]');
            let customValidation = form.querySelectorAll('.second-step input[data-custom-validation][type="text"]');
            let requiredTextarea = form.querySelectorAll('.second-step textarea[required]');
            let requiredCheckbox = form.querySelectorAll('.second-step input[type="checkbox"][required]');
            let requiredSelect = form.querySelectorAll('.second-step select[required]');
            customValidation.forEach(function (field){
                let fieldValue = field.value.trim();
                let fieldRegExp = field.dataset.customValidation;
                if (fieldValue !== '' && fieldRegExp) {
                    if (customValidate(field.value,fieldRegExp) != true) {
                        validation = false;
                        if(field.closest('.form-group-input')){
                            field.closest('.form-group-input').classList.add('hasError');
                        }
                        if(field.closest('.wrapper-inputs__item')){
                            field.closest('.wrapper-inputs__item').classList.add('hasError');
                            if(field.closest('.wrapper-inputs__item').querySelector('.error-message')){
                                field.closest('.wrapper-inputs__item').querySelector('.error-message').innerHTML = window.errors.custom_validation_error
                            }
                        }
                    }else {
                        if(field.closest('.form-group-input')) {
                            field.closest('.form-group-input').classList.remove('hasError');
                        }
                        if(field.closest('.wrapper-inputs__item')) {
                            field.closest('.wrapper-inputs__item').classList.remove('hasError');
                        }
                    }
                }
            });
            requiredFields.forEach(function (field){
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    validation = false;
                    if(field.closest('.form-group-input')){
                        field.closest('.form-group-input').classList.add('hasError');
                    }
                    if(field.closest('.wrapper-inputs__item')){
                        field.closest('.wrapper-inputs__item').classList.add('hasError');
                        if(field.closest('.wrapper-inputs__item').querySelector('.error-message')){
                            field.closest('.wrapper-inputs__item').querySelector('.error-message').innerHTML = window.errors.required_error
                        }
                    }
                }else{
                    if(!field.hasAttribute('data-custom-validation')){
                        if(field.closest('.form-group-input')) {
                            if(!field.closest('.form-group-input').classList.contains('double-input')){
                                field.closest('.form-group-input').classList.remove('hasError');
                            }else {
                                if(field.closest('.form-group-input').firstElementChild == field.closest('.form-group-input-wrapper')){
                                    field.closest('.form-group-input').classList.remove('hasError');
                                }
                            }

                        }
                        if(field.closest('.wrapper-inputs__item')) {
                            if(!field.closest('.form-group-input').classList.contains('double-input')){
                                field.closest('.wrapper-inputs__item').classList.remove('hasError');
                            }else {
                                if(field.closest('.form-group-input').firstElementChild == field.closest('.form-group-input-wrapper')){
                                    field.closest('.wrapper-inputs__item').classList.remove('hasError');
                                }
                            }
                        }
                    }
                }
            });
            requiredEmail.forEach(function (field){

                let fieldValue = field.value.trim();

                if (fieldValue === '') {
                    validation = false;
                    if(field.closest('.form-group-input')) {
                        field.closest('.form-group-input').classList.add('hasError');
                    }
                    if(field.closest('.wrapper-inputs__item')){
                        field.closest('.wrapper-inputs__item').classList.add('hasError');
                        if(field.closest('.wrapper-inputs__item').querySelector('.error-message')){
                            field.closest('.wrapper-inputs__item').querySelector('.error-message').innerHTML = window.errors.required_error
                        }
                    }
                }else {
                    if (validateEmail(field.value) != true) {
                        validation = false;
                        if(field.closest('.form-group-input')){
                            field.closest('.form-group-input').classList.add('hasError');
                        }
                        if(field.closest('.wrapper-inputs__item')){
                            field.closest('.wrapper-inputs__item').classList.add('hasError');
                            if(field.closest('.wrapper-inputs__item').querySelector('.error-message')){
                                field.closest('.wrapper-inputs__item').querySelector('.error-message').innerHTML = window.errors.email_error
                            }
                        }
                    }else {
                        if(field.closest('.form-group-input')) {
                            field.closest('.form-group-input').classList.remove('hasError');
                        }
                        if(field.closest('.wrapper-inputs__item')) {
                            field.closest('.wrapper-inputs__item').classList.remove('hasError');
                        }
                    }
                }
            });
            phone.forEach(function (field){
                let fieldValue = field.value.trim();
                if (fieldValue !== '') {
                    if (validatePhone(field.value) != true) {
                        validation = false;
                        if(field.closest('.form-group-input')){
                            field.closest('.form-group-input').classList.add('hasError');
                        }
                        if(field.closest('.wrapper-inputs__item')){
                            field.closest('.wrapper-inputs__item').classList.add('hasError');
                            if(field.closest('.wrapper-inputs__item').querySelector('.error-message')){
                                field.closest('.wrapper-inputs__item').querySelector('.error-message').innerHTML = window.errors.phone_error
                            }
                        }
                    }else {
                        if(field.closest('.form-group-input')) {
                            field.closest('.form-group-input').classList.remove('hasError');
                        }
                        if(field.closest('.wrapper-inputs__item')) {
                            field.closest('.wrapper-inputs__item').classList.remove('hasError');
                        }
                    }
                }else{
                    if(field.hasAttribute('required')){
                        validation = false;
                        if(field.closest('.form-group-input')){
                            field.closest('.form-group-input').classList.add('hasError');
                        }
                        if(field.closest('.wrapper-inputs__item')){
                            field.closest('.wrapper-inputs__item').classList.add('hasError');
                            if(field.closest('.wrapper-inputs__item').querySelector('.error-message')){
                                field.closest('.wrapper-inputs__item').querySelector('.error-message').innerHTML = window.errors.required_error
                            }
                        }
                    }
                }
            });
            requiredTextarea.forEach(function (field){
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    validation = false;
                    if(field.closest('.form-group-input')){
                        field.closest('.form-group-input').classList.add('hasError');
                    }
                    if(field.closest('.wrapper-inputs__item')){
                        field.closest('.wrapper-inputs__item').classList.add('hasError');
                        if(field.closest('.wrapper-inputs__item').querySelector('.error-message')){
                            field.closest('.wrapper-inputs__item').querySelector('.error-message').innerHTML = window.errors.required_error
                        }
                    }
                }else{
                    if(field.closest('.form-group-input')) {
                        field.closest('.form-group-input').classList.remove('hasError');
                    }
                    if(field.closest('.wrapper-inputs__item')) {
                        field.closest('.wrapper-inputs__item').classList.remove('hasError');
                    }
                }
            });
            requiredCheckbox.forEach(function (field){
                let fieldValue = field.value.trim();
                if (field.checked === false) {
                    validation = false;
                    if(field.closest('.wrapper-inputs__item')){
                        field.closest('.wrapper-inputs__item').classList.add('hasErrorСheckbox');
                    }
                }else{
                    if(field.closest('.wrapper-inputs__item')) {
                        field.closest('.wrapper-inputs__item').classList.remove('hasErrorСheckbox');
                    }
                }
            });
            requiredSelect.forEach(function (field){
                let fieldValue = field.value.trim();
                if (fieldValue === '') {
                    validation = false;
                    if(field.closest('.form-group-input')){
                        field.closest('.form-group-input').classList.add('hasError');
                    }
                    if(field.closest('.wrapper-inputs__item')){
                        field.closest('.wrapper-inputs__item').classList.add('hasError');
                        if(field.closest('.wrapper-inputs__item').querySelector('.error-message')){
                            field.closest('.wrapper-inputs__item').querySelector('.error-message').innerHTML = window.errors.required_error
                        }
                    }
                }else{
                    if(field.closest('.form-group-input')) {
                        field.closest('.form-group-input').classList.remove('hasError');
                    }
                    if(field.closest('.wrapper-inputs__item')) {
                        field.closest('.wrapper-inputs__item').classList.remove('hasError');
                    }
                }
            });
            console.log('form validation:'+validation)
            if (validation) {
                if(form.classList.contains('js-newsletter-subscribe')){
                    newsletterSubscribe(form);
                }else{
                    // form.submit();
                    form.querySelector('.reserveInStore-form-submit').click();
                    button.setAttribute('disabled', 'disabled');
                }
                return form;
            }else{
                if(form.querySelector('.wrapper-inputs__item.hasError')){
                    form.querySelector('.wrapper-inputs__item.hasError').scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                }
            }
        })
    });
    if (forms.length > 0) {
        // document.body.addEventListener("input", function (event) {
        //     if(event.target.closest('.form-group-input')){
        //         if (event.target.closest('.form-group-input').classList.contains("hasError")) {
        //             event.target.closest('.form-group-input').classList.remove("hasError");
        //         }
        //         if (event.target.closest('.wrapper-inputs__item').classList.contains("hasError")) {
        //             event.target.closest('.wrapper-inputs__item').classList.remove("hasError");
        //         }
        //     }
        // });
    }
    let phoneInput = document.querySelectorAll('.js-reserve-form-validation form .second-step input[data-phone-mask]');
    if(phoneInput){
        phoneInput.forEach(function (element){
            const mask = IMask(element, {
                mask: element.dataset.phoneMask
            });
        })
    }
};